var map = {
	"./cake.webp": 1969,
	"./crown-blue.webp": 1970,
	"./crown.webp": 1971,
	"./pocket.webp": 1972,
	"./present.webp": 1973,
	"./relegation.webp": 1974,
	"./t-deposit.webp": 1975,
	"./t-turnover.webp": 1976,
	"./vip-bg.webp": 1977,
	"./vip1.gif": 1978,
	"./vip1.webp": 1979,
	"./vip10-bg.webp": 1980,
	"./vip10.gif": 1981,
	"./vip10.webp": 1982,
	"./vip11-bg.webp": 1983,
	"./vip11.gif": 1984,
	"./vip11.webp": 1985,
	"./vip12-bg.webp": 1986,
	"./vip12.gif": 1987,
	"./vip12.webp": 1988,
	"./vip2.gif": 1989,
	"./vip2.webp": 1990,
	"./vip3.gif": 1991,
	"./vip3.webp": 1992,
	"./vip4.gif": 1993,
	"./vip4.webp": 1994,
	"./vip5.gif": 1995,
	"./vip5.webp": 1996,
	"./vip6.gif": 1997,
	"./vip6.webp": 1998,
	"./vip7.gif": 1999,
	"./vip7.webp": 2000,
	"./vip8.gif": 2001,
	"./vip8.webp": 2002,
	"./vip9.gif": 2003,
	"./vip9.webp": 2004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;